export default __webpack_public_path__ + "static/media/Pack Power.5c8de72b.png";